export default __webpack_public_path__ + "AngloApplicantsUpload_recruitment.xlsx";